import BasePage from "@Scripts/Pages/BasePage";

export default class HomePage extends BasePage {
    private static ytPlayer: any = null;

    public static async init() {
        await super.init();

        this.setYTPlayer();
        this.setCarosel();
    }

    private static setYTPlayer() {
        const self = this;
        //Add YT Player node
        let playerTag = document.createElement("div");
        playerTag.id = "YTPlayer";
        playerTag.className = "yt-player";

        let visualYT = document.getElementById("Visual");
        if (visualYT != null) {
            visualYT.children[0].appendChild(playerTag);

            window["YT"].ready(function () {
                //Handle video in YT
                self.ytPlayer = new window["YT"].Player("YTPlayer", {
                    host: "https://www.youtube.com",
                    videoId: visualYT.dataset.videoid,
                    height: 840,
                    width: 1491,
                    playerVars: {
                        loop: 1,
                        playlist: visualYT.dataset.videoid,
                        enablejsapi: 1,
                        fs: 0,
                        rel: 0,
                        showinfo: 0,
                        controls: 0,
                        modestbranding: 1,
                        iv_load_policy: 3,
                        autohide: 0,
                        origin: window.location.origin
                    },
                    events: {
                        "onReady": self.onYTPlayerReady
                    }
                });
            });
        }
    }

    private static onYTPlayerReady(event: any) {
        event.target.setVolume(0);
        event.target.playVideo();
    }

    private static setCarosel() {
        const visuals = new (<any>window).Swiper(".app-visual", {
            modules: [(<any>window).Pagination, (<any>window).Navigation, (<any>window).Autoplay],
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 4000,
            },
            pagination: {
                el: ".slide-count",
                type: "bullets",
                clickable: false,
                renderBullet: function (index, className) {
                    return "<div class=\"item \ " + className + "\"></div>";
                }
            },
            navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
            },
        });
    }
}